import store from '@/store'

/**
 * v-auth 权限指令
 * 用法：v-auth="'menu:add'" 或 v-auth="['menu:add', 'menu:edit']"
 * 检查当前用户 action 中是否包含对应 identity 标识
 */
const hasPermission = (value) => {
    if (!value) return true

    const action = store.getters['basic/get_action'] || []
    const identities = action
        .filter(item => item.identity)
        .map(item => item.identity)

    if (Array.isArray(value)) {
        return value.some(v => identities.includes(v))
    }

    return identities.includes(value)
}

const toggleAuthDisplay = (el, value) => {
    if (typeof el.__authOriginalDisplay === 'undefined') {
        el.__authOriginalDisplay = el.style.display || ''
    }

    el.style.display = hasPermission(value) ? el.__authOriginalDisplay : 'none'
}

const auth = {
    mounted(el, binding) {
        toggleAuthDisplay(el, binding.value)
        el.__authUnwatch = store.watch(
            (_state, getters) => getters['basic/get_action'],
            () => {
                toggleAuthDisplay(el, binding.value)
            },
            {
                deep: true,
            }
        )
    },
    updated(el, binding) {
        toggleAuthDisplay(el, binding.value)
    },
    unmounted(el) {
        if (typeof el.__authUnwatch === 'function') {
            el.__authUnwatch()
            delete el.__authUnwatch
        }
        delete el.__authOriginalDisplay
    },
}

export default auth
